module.exports = __webpack_public_path__ + "static/media/08_digginglight.7996877b.jpg";